import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { User, UserType } from '../../models/user';
import { UserService } from '../services/user.service';
import { CompanyStatus } from '../../models/common';
import { EventTrackerService, Page, TargetType, UserActionType } from '../services/event-tracker/event-tracker.service';
import { PopperContent } from '../../../node_modules/ngx-popper';
import { Location, PlatformLocation } from '@angular/common';
import { ModalService } from '../services/modal/modal.service';
import { AchooPopupComponent } from '../core/achoo-popup/achoo-popup.component';
import { CommonConstant, defaultPlatformSettings } from '../app.constants';
import { CacheService } from '../services/cache/cache.service';
import { DiscoverService } from '../services/discover/discover.service';
import { AppSettings } from '../utils/app-settings';
import { PdfExportService } from '../services/export-pdf/pdf-export.service';
import { InfluencerGroupsService } from './influencer-groups/influencer-groups.service';
import { timer } from 'rxjs/observable/timer';
import { concatMap, filter } from 'rxjs/operators';
import { ObjectUtils } from '../utils/object.utils';
var MainComponent = /** @class */ (function () {
    function MainComponent(auth, router, location, platformLocation, activatedRoute, userService, eventTracker, modalService, cacheService, discoverService, pdfExportService, influenderGroupsService) {
        var _this = this;
        this.auth = auth;
        this.router = router;
        this.location = location;
        this.platformLocation = platformLocation;
        this.activatedRoute = activatedRoute;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.modalService = modalService;
        this.cacheService = cacheService;
        this.discoverService = discoverService;
        this.pdfExportService = pdfExportService;
        this.influenderGroupsService = influenderGroupsService;
        // define flag to prevent send duplicate MP event
        this.haveSentViewEventTracking = false;
        this.showPendingInfluencerIndicator = false;
        this.sampleSetupData = [];
        this.showAccountList = false;
        this.user = new User();
        this.userService.platformSettings.subscribe(function (setting) {
            _this.platformSettings = setting;
        });
        platformLocation.onPopState(function () {
            _this.cacheService.disableCacheRemoving();
        });
        router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
        router.events.forEach(function (event) {
            if (event instanceof NavigationEnd && _this.currentCompanyId) {
                if (_this.auth.isAuth() && event.url.indexOf('activeAccount=') < 0 && event.urlAfterRedirects !== '/404') {
                    _this.updateRouteUrl(event.url, _this.currentCompanyId, _this.activatedRoute.snapshot.queryParams);
                }
                if (event.url.indexOf('/discover') >= 0) {
                    _this.discoverService.activeDiscoverPage();
                    _this.scrollToLastPosition();
                    _this.discoverService.onLeaveDiscoverPage(false);
                }
                else {
                    _this.discoverService.inactiveDiscoverPage();
                    _this.discoverService.onLeaveDiscoverPage(true);
                }
                if (event.url.indexOf('influencer/') < 0 && _this.cacheService.shouldRemoveCachedData) {
                    _this.cacheService.clearAll();
                }
                var path = event.url.split('?')[0];
                if (!_this.haveSentViewEventTracking) {
                    _this.trackUserNavigation(activatedRoute.snapshot.routeConfig.children, path.substring(1));
                    _this.haveSentViewEventTracking = true;
                }
            }
        });
    }
    MainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.user = this.auth.getUser();
        this.triggerSignUpEvent();
        if (this.user.type === UserType.INFLUENCER) {
            this.campaignRouterLink = ['/framed/influencerCampaigns'];
        }
        else {
            this.campaignRouterLink = ['/campaigns'];
        }
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (params['activeAccount'] && Number(params['activeAccount']) !== _this.userService.getCompanyId()) {
                _this.userService.setCompanyId(Number(params['activeAccount']), true);
            }
        });
        if (this.user.type === UserType.ADMIN || this.user.type === UserType.AGENCY) {
            this.companyList = this.userService.getAdvertiserList().filter(function (x) { return _this.canShowAdvertiser(x); });
            this.companyIdSubjectSubscription = this.userService.companyId.subscribe(function (id) {
                _this.currentCompanyId = id;
                // update active account queryParams
                var queryParams = _this.activatedRoute.snapshot.queryParams;
                _this.updateRouteUrl(_this.router.url.split('?')[0], id, queryParams);
            });
        }
        if (this.user.type === UserType.ADVERTISER) {
            this.currentCompanyId = this.userService.getCompanyId();
        }
        this._activatedInfluencersSubscription = this.userService.activeInfluencers$.subscribe(function (data) { return _this.activatedInfluencersData = data; });
        // list invalid action by level event
        this.checkingAccountLevelSubscription = this.userService.invalidActionLevelObject.subscribe(function (res) {
            if (res) {
                _this.invalidLevelMsg = res.message;
                _this.invalidActionByLevelWarningRef = _this.modalService.openInCenter(_this.invalidActionByLevelWarning, function () {
                    _this.tracWallNotificationUsage(true, TargetType.BACKDROP);
                    _this.invalidLevelMsg = undefined;
                }, 'invalid-level-modal');
                _this.userService.resetInvalidActionObject();
            }
        });
        this.haveSentViewEventTracking = false;
        this.cacheService.enableCacheRemoving();
        this.pollPendingInfluecer(this.currentCompanyId);
        this.exposeSampleDataSetupFunctions();
        // handling contact support
        this.supportContactSubscription = this.userService.contactSupportRequested.subscribe({
            next: function () { return _this.closePopupAndOpenIntercom(); }
        });
    };
    MainComponent.prototype.ngOnDestroy = function () {
        this.discoverService.disableCachingScrollPosition();
        if (this.companyIdSubjectSubscription) {
            this.companyIdSubjectSubscription.unsubscribe();
        }
        if (this.checkingAccountLevelSubscription) {
            this.checkingAccountLevelSubscription.unsubscribe();
        }
        if (this.reportExportingSubscription) {
            this.reportExportingSubscription.unsubscribe();
        }
        if (this.reportExportingErrorSubscription) {
            this.reportExportingErrorSubscription.unsubscribe();
        }
        if (this.pollingPendingInfluencerSubscription) {
            this.pollingPendingInfluencerSubscription.unsubscribe();
        }
        if (this.startPremiumTrialSubscription) {
            this.startPremiumTrialSubscription.unsubscribe();
        }
        if (this.supportContactSubscription) {
            this.supportContactSubscription.unsubscribe();
        }
        if (this._activatedInfluencersSubscription) {
            this._activatedInfluencersSubscription.unsubscribe();
        }
    };
    MainComponent.prototype.scrollToLastPosition = function () {
        var _this = this;
        if (this.cacheService.has(CommonConstant.DISCOVER_SCROLL_TOP)) {
            this.cacheService.get(CommonConstant.DISCOVER_SCROLL_TOP).subscribe(function (pos) {
                if ((document.documentElement.scrollHeight * 0.9) > pos) {
                    // deactive infinitive loading while scrolling to last position
                    _this.discoverService.onScrollToPreviousPosition(true);
                    // active infinitive loading after 1s
                    setTimeout(function () {
                        window.scrollTo(0, pos);
                        _this.discoverService.onScrollToPreviousPosition(false);
                        _this.discoverService.enableCachingScrollPosition();
                    }, 1000);
                }
            });
        }
        else {
            this.discoverService.enableCachingScrollPosition();
        }
    };
    MainComponent.prototype.toggleMobileMenu = function () {
        document.getElementById('mobile-menu').classList.toggle('show');
    };
    MainComponent.prototype.logout = function () {
        this.auth.logout();
        return false;
    };
    MainComponent.prototype.hideAccountList = function () {
        this.showAccountList = false;
    };
    MainComponent.prototype.openAccountList = function () {
        this.showAccountList = true;
    };
    MainComponent.prototype.updateRouteUrl = function (pathUrl, companyId, params) {
        if (params === void 0) { params = {}; }
        var queryParams = Object.assign({}, params, { activeAccount: companyId });
        var baseRouteUrl = pathUrl.split('?')[0];
        var url = this.router.createUrlTree([baseRouteUrl], {
            queryParams: queryParams
        }).toString();
        this.location.replaceState(url);
    };
    MainComponent.prototype.changeAccount = function (companyId) {
        this.userService.setCompanyId(companyId, true, true);
        if (this.pollingPendingInfluencerSubscription) {
            this.pollingPendingInfluencerSubscription.unsubscribe();
        }
        this.pollPendingInfluecer(this.currentCompanyId);
    };
    MainComponent.prototype.openIntercom = function () {
        this.modalService.openInCenter(this.supportForm);
        setTimeout(function () {
            var hubspotFormContainer = document.querySelector('.support-hubspot-form');
            if (hubspotFormContainer) {
                var hubspotFormIframe = hubspotFormContainer.querySelector('.hs-form-iframe');
                if (!hubspotFormIframe) {
                    hbspt.forms.create({
                        portalId: '8031552',
                        formId: AppSettings.mmiHubSpotFormId(),
                        target: '.support-hubspot-form'
                    });
                }
            }
        }, 200);
    };
    MainComponent.prototype.popperOnShown = function (e) {
        this.showFadedBg = true;
    };
    MainComponent.prototype.popperOnHidden = function (e) {
        this.showFadedBg = false;
        this.changeAccountPopper.hide();
    };
    Object.defineProperty(MainComponent.prototype, "platformBgColor", {
        get: function () {
            return this.platformSettings ? this.platformSettings.platformBgColor : defaultPlatformSettings.platformBgColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.leftSidebarLogoImage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainComponent.prototype, "hasCreditBasedBilling", {
        get: function () {
            return this.userService.hasCreditBaseBilling();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainComponent.prototype, "isDisableInboxPage", {
        get: function () {
            return this.userService.isFreeUser() || AppSettings.isDisableChat();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainComponent.prototype, "needToUpgradeAccount", {
        get: function () {
            return !this.userService.isFreeUser() || this.userService.hasStartedTrial();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainComponent.prototype, "faqLink", {
        get: function () {
            return AppSettings.faqLink();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainComponent.prototype, "isSsoUser", {
        get: function () {
            return this.userService.isSsoUser;
        },
        enumerable: true,
        configurable: true
    });
    MainComponent.prototype.closeAlertPopup = function () {
        this.modalService.close();
    };
    MainComponent.prototype.closeWallNotification = function (targetType) {
        this.tracWallNotificationUsage(false, targetType);
        if (this.invalidActionByLevelWarningRef) {
            this.modalService.closeSinglePopup(this.invalidActionByLevelWarningRef);
        }
    };
    MainComponent.prototype.closePopupAndOpenIntercom = function () {
        this.modalService.close();
        this.openIntercom();
    };
    MainComponent.prototype.upgradeAccount = function (evt) {
        this.closeWallNotification();
        return this.router.navigate(['account-settings', 'billing']);
    };
    MainComponent.prototype.contactSupport = function () {
        this.closeWallNotification();
        this.openIntercom();
    };
    MainComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    MainComponent.prototype.trackUserNavigation = function (childRoutes, urlNavigation) {
        var activatedRoute = childRoutes.find(function (route) { return route.path === urlNavigation; });
        if (activatedRoute && activatedRoute.data && activatedRoute.data.segmentItem) {
            this.eventTracker.trackUserAction(UserActionType.VIEW, activatedRoute.data.segmentItem, undefined, undefined, undefined, {
                type: activatedRoute.data.segmentActivePage
            });
        }
    };
    MainComponent.prototype.tracWallNotificationUsage = function (needSupport, targetType) {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.WALL_NOTIFICATION, {
            name: needSupport ? 'Support' : 'OK',
            type: targetType ? targetType : TargetType.BUTTON
        }, {
            action: UserActionType.TOGGLE
        });
    };
    MainComponent.prototype.pollPendingInfluecer = function (companyId) {
        var _this = this;
        if (this.cacheService.has("influencer_group_list_" + companyId)) {
            this.cacheService.clear("influencer_group_list_" + companyId);
        }
        this.pollingPendingInfluencerSubscription = timer(0, AppSettings.getDefaultTimer())
            .pipe(filter(function () {
            // make sure not polling influncer if current account is inactive
            var ad = _this.userService.getCurrentAdvertiser();
            return ad && !ad.inactive;
        }), concatMap(function () { return _this.influenderGroupsService.getInfluencerGroups(companyId); })).subscribe(function (res) {
            _this.cacheService.set("influencer_group_list_" + companyId, res);
            var filteredPendingInfItem = res.filter(function (item) { return item.totalPendingInfluencers > 0; });
            var isGroupPage = _this.router.url.indexOf('groups') < 0;
            _this.showPendingInfluencerIndicator = isGroupPage && filteredPendingInfItem && filteredPendingInfItem.length > 0;
        });
    };
    Object.defineProperty(MainComponent.prototype, "userAvatar", {
        get: function () {
            var userData = ObjectUtils.parseJSON(localStorage.getItem('user'));
            return userData && userData.data && userData.data.image ? userData.data.image : CommonConstant.DEFAULT_USER_AVATAR;
        },
        enumerable: true,
        configurable: true
    });
    MainComponent.prototype.exposeSampleDataSetupFunctions = function () {
        var _this = this;
        window['sampleDataSetupFunctions'] = {
            loadSetups: function (callback) {
                _this.loadSampleData(callback);
            },
            createSampleData: function (sampleDataSetUpId, callback) {
                _this.createSampleData(sampleDataSetUpId, _this.currentCompanyId, callback);
            }
        };
    };
    MainComponent.prototype.loadSampleData = function (callback) {
        var _this = this;
        return this.userService.getSampleData().subscribe(function (res) {
            _this.sampleSetupData = res;
            _this.sendMixpanelEvent();
            callback(null, res);
        }, function (error) {
            callback(error, null);
        });
    };
    MainComponent.prototype.createSampleData = function (sampleDataSetUpId, companyId, callback) {
        var _this = this;
        return this.userService.createSampleData(sampleDataSetUpId, companyId).subscribe(function (res) {
            var choosingSampleData = _this.sampleSetupData.filter(function (item) { return item.id === sampleDataSetUpId; })[0];
            _this.sendMixpanelEvent(choosingSampleData);
            callback(null, res);
        }, function (error) {
            callback(error, null);
        });
    };
    MainComponent.prototype.sendMixpanelEvent = function (targetData) {
        var target = targetData ? { id: targetData.id, name: targetData.label } : null;
        this.eventTracker.trackUserAction(UserActionType.ONBOARDING, null, target, {
            action: targetData ? UserActionType.CHOSE_DATA_SAMPLE : UserActionType.LOAD_DATA_SAMPLES
        }, undefined, null, null);
    };
    MainComponent.prototype.triggerSignUpEvent = function () {
        var queryParams = this.activatedRoute.snapshot.queryParams;
        if (queryParams.accessToken && queryParams.signup === 'true') {
            this.eventTracker.trackUserSignup(this.auth.getUser(), false);
            var normalizeQueryParams_1 = {};
            Object.keys(queryParams).forEach(function (k) {
                if (k !== 'accessToken' && k !== 'signup') {
                    Object.defineProperty(normalizeQueryParams_1, k, {
                        value: queryParams[k]
                    });
                }
            });
            return this.router.navigate([this.router.url.split('?')[0]], normalizeQueryParams_1);
        }
    };
    MainComponent.prototype.isEnableInfluencerReviewFeature = function () {
        return AppSettings.isEnableInfluencerReview();
    };
    MainComponent.prototype.canShowAdvertiser = function (adv) {
        return adv.status !== CompanyStatus.BLOCKED && adv.status !== CompanyStatus.CHURNED;
    };
    return MainComponent;
}());
export { MainComponent };



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts.pre-build-optimizer.js